"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var AllowedIntents = {
  LEAD_FLOWS: 'LEAD_FLOWS',
  MEETINGS: 'MEETINGS',
  CONVERSATIONS: 'CONVERSATIONS',
  DOCUMENTS: 'DOCUMENTS',
  FORMS: 'FORMS',
  SALES_FREE: 'SALES_FREE',
  SALES_O365: 'SALES_O365',
  MARKETING_FREE_EMAIL: 'MARKETING_FREE_EMAIL',
  SALES_VSTO: 'SALES_VSTO',
  MARKETING_ADS: 'MARKETING_ADS',
  TRIAL: 'TRIAL'
};
var _default = AllowedIntents;
exports.default = _default;
module.exports = exports.default;